module.exports = __webpack_public_path__ + "img/train-stop-ground.b76045ac.png";